import { render, staticRenderFns } from "./PasswordChangeBox.vue?vue&type=template&id=15b15482"
import script from "./PasswordChangeBox.vue?vue&type=script&lang=js"
export * from "./PasswordChangeBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports